module.exports = __webpack_public_path__ + "static/media/ManUnsign.badc03e0.svg";